import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { LoaderService } from './loader.service';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private router: Router,
    private loaderService: LoaderService // Inject LoaderService properly
  ) {}

  // Common headers for requests
  header = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    }),
  };

  headerMedia = {
    headers: new HttpHeaders({
      // 'Content-Type': 'multipart/form-data'
    }),
  };

  // Header with authorization token
  get headerToken() {
    const token: any = localStorage.getItem('token');
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*', Authorization: `Bearer ${JSON.parse(token)}`, // Fixed template literal
      }),
       
    };
  }

  downloadFile(url: string, data: any, token: boolean = false) {
    LoaderService.loader.next(true);
    return this.http
      .post(environment.baseUrl + url, data, {
        headers: token ? this.headerToken.headers : this.header.headers,
        responseType: 'blob', 
      })
      .pipe(
        finalize(() => LoaderService.loader.next(false)),
        catchError((error: HttpErrorResponse) => {
          LoaderService.loader.next(false);
          this.toastr.error('Download failed. Please try again.');
          return throwError(error.message || 'Server error');
        })
      );
  }

  get headerTokenMedia() {
    const token:any = localStorage.getItem('token');
    return {
      headers: new HttpHeaders({
        // 'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*', Authorization: `Bearer ${JSON.parse(token)}`, // Fixed template literal

      }),
    };
  }

  // POST method for sending data
  post(url: string, data: any, token: boolean) {
    LoaderService.loader.next(true);
  
    return this.http
      .post(
        environment.baseUrl + url,
        data,
        token ? this.headerToken : this.header
      )
      .pipe(
        finalize(() => LoaderService.loader.next(false)),
        tap((res: any) => {
          if (res?.message || res?.messsage) {
            this.toastr.success(res?.message ? res?.message : res?.messsage);
          }
        }),
        catchError((error: HttpErrorResponse) => {
          console.log(error);
  
          // Show error from 'errors' or fallback to default message
          if (error?.error?.errors) {
            this.toastr.error(error.error.errors);
          } else if (error?.error?.error) {
            this.toastr.error(error.error.error);
          } else {
            this.toastr.error('Server error');
          }
  
          return throwError(() => error);
        })
      );
  }
  

  fileDownload(url: string, data: any, token: boolean = false) {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Accept': 'application/octet-stream', // Ensure binary data is accepted
    });
  
    return this.http.post(environment.baseUrl + url, data, {
      headers: headers,
      responseType: 'blob',  // Important: handle binary response (file download)
    }).pipe(
      finalize(() => LoaderService.loader.next(false)),
      tap((res: Blob) => {
        console.log('File download started', res); // Handle the blob response
      }),
      catchError((error: HttpErrorResponse) => {
        LoaderService.loader.next(false);
        return throwError(error.message || 'Server error');
      })
    );
  }

  postMedia(url: string, data: any, token: boolean) {
    LoaderService.loader.next(true);
  
    return this.http
      .post(
        environment.baseUrl + url,
        data,
        token ? this.headerTokenMedia : this.headerMedia
      )
      .pipe(
        finalize(() => LoaderService.loader.next(false)),
        tap((res: any) => {
          if (res?.message || res?.messsage) {
            this.toastr.success(res?.message || res?.messsage);
          }
        }),
        catchError((error: HttpErrorResponse) => {
          // Prefer showing 'errors', then 'error', then 'message', then fallback
          const backendError =
            error.error?.errors ||
            error.error?.error ||
            error.error?.message ||
            'Server error';
  
          this.toastr.error(backendError);
  
          return throwError(() => backendError);
        })
      );
  }
  


  // POST method for uploading files
  filePost(url: string, data: any, token: boolean = false) {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
    });

    LoaderService.loader.next(true); // Trigger loader
    return this.http
      .post(environment.baseUrl + url, data, { headers: headers })
      .pipe(
        finalize(() =>LoaderService.loader.next(false)),
        tap((res: any) => {
          if (res?.message) {
            this.toastr.success(res.message);
          }
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(() => new Error(error.message || 'Server error'));
        })
      );
  }

  // GET method for retrieving data
  get(url: string, token: boolean) {
    LoaderService.loader.next(true);
    return this.http
      .get(environment.baseUrl + url, token ? this.headerToken : this.header)
      .pipe(
        finalize(() =>  LoaderService.loader.next(false)),
        tap((res: any) => {
          if (res?.message || res?.messsage) {
            console.log('response', res?.message);
          }
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(() => new Error(error.message || 'Server error'));
        })
      );
  }
}
